var _path, _path2, _g, _path3, _g2, _g3, _path4, _path5, _path6, _path7, _path8, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMaxDepth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 103,
    height: 224,
    viewBox: "0 0 103 224",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.42692 4.40649C1.42692 2.69108 2.81754 1.30045 4.53296 1.30045H99.0033C100.719 1.30045 102.109 2.69108 102.109 4.40649V208.665C102.109 209.954 101.333 211.085 100.144 211.518C96.1926 212.955 88.0637 215.788 78.9259 218.261C69.7701 220.738 59.676 222.833 51.7681 222.833C43.8603 222.833 33.7662 220.738 24.6104 218.261C15.4725 215.788 7.34365 212.955 3.39216 211.518C2.2034 211.085 1.42692 209.954 1.42692 208.665V4.40649Z",
    fill: "white",
    stroke: "#CECED9",
    strokeWidth: 1.75813
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_13988_295305",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 7,
    width: 100,
    height: 217
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M101.256 7.54736H2.27163V211.234C2.27163 211.83 2.66371 212.353 3.23722 212.516C9.21208 214.208 41.2033 223.15 50.8196 223.435C60.4629 223.72 94.1627 214.263 100.295 212.516C100.867 212.353 101.256 211.832 101.256 211.236V7.54736Z",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_13988_295305)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    filter: "url(#filter0_i_13988_295305)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.454674 233.251H51.6753H102.896C102.896 229.664 102.896 110.742 102.896 105.112C61.465 118.753 56.1967 102.928 31.7465 101.215C17.4393 100.212 0.454704 105.112 0.454704 105.112C0.454704 105.112 0.454674 231.051 0.454674 233.251Z",
    fill: "url(#paint0_linear_13988_295305)"
  }))))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.42692 4.40649C1.42692 2.69108 2.81754 1.30045 4.53296 1.30045H99.0033C100.719 1.30045 102.109 2.69108 102.109 4.40649V208.665C102.109 209.954 101.333 211.085 100.144 211.518C96.1926 212.955 88.0637 215.788 78.9259 218.261C69.7701 220.738 59.676 222.833 51.7681 222.833C43.8603 222.833 33.7662 220.738 24.6104 218.261C15.4725 215.788 7.34365 212.955 3.39216 211.518C2.2034 211.085 1.42692 209.954 1.42692 208.665V4.40649Z",
    stroke: "url(#paint1_linear_13988_295305)",
    strokeWidth: 1.75813
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_13988_295305)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31.1776,
    height: 6.23552,
    rx: 0.890788,
    transform: "matrix(-1 0 0 1 66.9131 5.3208)",
    fill: "#5870E0"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_i_13988_295305)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 102.441,
    height: 6.23552,
    rx: 1.78158,
    transform: "matrix(-1 0 0 1 102.989 0.421387)",
    fill: "#8F90A6"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M50.8561 166.033L51.8672 211.905",
    stroke: "#656D88",
    strokeWidth: 1.75813,
    strokeLinecap: "round",
    strokeDasharray: "3.52 5.86"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8672 21.3911L51.8671 120.139",
    stroke: "#656D88",
    strokeWidth: 1.75813,
    strokeLinecap: "round",
    strokeDasharray: "3.52 5.86"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3014 127.841V136.976H27.803V130.72L25.0165 136.976H23.9781L21.1785 130.72V136.976H19.6801V127.841H21.2968L24.5039 135.004L27.6979 127.841H29.3014ZM30.7714 133.322C30.7714 132.595 30.9203 131.951 31.2183 131.39C31.525 130.829 31.9368 130.395 32.4538 130.089C32.9796 129.773 33.5579 129.615 34.1888 129.615C34.7584 129.615 35.2534 129.729 35.6741 129.957C36.1034 130.176 36.4452 130.452 36.6993 130.785V129.734H38.2108V136.976H36.6993V135.898C36.4452 136.24 36.099 136.525 35.6609 136.753C35.2228 136.98 34.7233 137.094 34.1625 137.094C33.5404 137.094 32.9708 136.937 32.4538 136.621C31.9368 136.297 31.525 135.85 31.2183 135.281C30.9203 134.702 30.7714 134.049 30.7714 133.322ZM36.6993 133.348C36.6993 132.849 36.5941 132.415 36.3838 132.047C36.1823 131.679 35.915 131.399 35.582 131.206C35.2491 131.013 34.8898 130.917 34.5042 130.917C34.1187 130.917 33.7594 131.013 33.4264 131.206C33.0935 131.39 32.8218 131.666 32.6115 132.034C32.41 132.393 32.3092 132.823 32.3092 133.322C32.3092 133.822 32.41 134.26 32.6115 134.636C32.8218 135.013 33.0935 135.302 33.4264 135.504C33.7682 135.697 34.1275 135.793 34.5042 135.793C34.8898 135.793 35.2491 135.697 35.582 135.504C35.915 135.311 36.1823 135.031 36.3838 134.663C36.5941 134.286 36.6993 133.848 36.6993 133.348ZM43.2809 133.309L45.6205 136.976H43.9249L42.3608 134.518L40.8887 136.976H39.3246L41.6642 133.414L39.3246 129.734H41.0201L42.5842 132.192L44.0564 129.734H45.6205L43.2809 133.309ZM47.5004 128.774C47.2287 128.774 47.0009 128.682 46.8169 128.498C46.6329 128.314 46.5409 128.086 46.5409 127.815C46.5409 127.543 46.6329 127.315 46.8169 127.131C47.0009 126.947 47.2287 126.855 47.5004 126.855C47.7633 126.855 47.9867 126.947 48.1707 127.131C48.3547 127.315 48.4467 127.543 48.4467 127.815C48.4467 128.086 48.3547 128.314 48.1707 128.498C47.9867 128.682 47.7633 128.774 47.5004 128.774ZM48.2364 129.734V136.976H46.738V129.734H48.2364ZM58.9707 129.615C59.5403 129.615 60.0485 129.734 60.4954 129.97C60.951 130.207 61.3059 130.557 61.56 131.022C61.8229 131.486 61.9543 132.047 61.9543 132.704V136.976H60.4691V132.928C60.4691 132.279 60.307 131.784 59.9828 131.442C59.6585 131.092 59.216 130.917 58.6552 130.917C58.0944 130.917 57.6475 131.092 57.3146 131.442C56.9903 131.784 56.8282 132.279 56.8282 132.928V136.976H55.343V132.928C55.343 132.279 55.1809 131.784 54.8566 131.442C54.5324 131.092 54.0899 130.917 53.5291 130.917C52.9683 130.917 52.5214 131.092 52.1884 131.442C51.8642 131.784 51.7021 132.279 51.7021 132.928V136.976H50.2037V129.734H51.7021V130.562C51.9475 130.264 52.2585 130.032 52.6353 129.865C53.0121 129.699 53.4152 129.615 53.8446 129.615C54.4229 129.615 54.9399 129.738 55.3955 129.984C55.8512 130.229 56.2017 130.584 56.4471 131.048C56.6661 130.61 57.0079 130.264 57.4723 130.01C57.9367 129.747 58.4362 129.615 58.9707 129.615ZM70.4198 129.734V136.976H68.9214V136.122C68.6848 136.42 68.3738 136.656 67.9882 136.831C67.6114 136.998 67.2083 137.081 66.779 137.081C66.2094 137.081 65.6968 136.963 65.2411 136.726C64.7942 136.49 64.4394 136.139 64.1765 135.675C63.9224 135.21 63.7953 134.65 63.7953 133.992V129.734H65.2806V133.769C65.2806 134.417 65.4427 134.917 65.7669 135.267C66.0911 135.609 66.5336 135.78 67.0944 135.78C67.6552 135.78 68.0977 135.609 68.422 135.267C68.7549 134.917 68.9214 134.417 68.9214 133.769V129.734H70.4198ZM81.1638 129.615C81.7334 129.615 82.2416 129.734 82.6885 129.97C83.1442 130.207 83.4991 130.557 83.7532 131.022C84.0161 131.486 84.1475 132.047 84.1475 132.704V136.976H82.6622V132.928C82.6622 132.279 82.5001 131.784 82.1759 131.442C81.8517 131.092 81.4092 130.917 80.8484 130.917C80.2876 130.917 79.8407 131.092 79.5077 131.442C79.1835 131.784 79.0214 132.279 79.0214 132.928V136.976H77.5361V132.928C77.5361 132.279 77.374 131.784 77.0498 131.442C76.7256 131.092 76.2831 130.917 75.7223 130.917C75.1615 130.917 74.7146 131.092 74.3816 131.442C74.0574 131.784 73.8953 132.279 73.8953 132.928V136.976H72.3969V129.734H73.8953V130.562C74.1406 130.264 74.4517 130.032 74.8285 129.865C75.2053 129.699 75.6084 129.615 76.0377 129.615C76.6161 129.615 77.133 129.738 77.5887 129.984C78.0444 130.229 78.3949 130.584 78.6402 131.048C78.8593 130.61 79.201 130.264 79.6654 130.01C80.1299 129.747 80.6293 129.615 81.1638 129.615ZM32.6903 150.322C32.6903 149.595 32.8393 148.951 33.1372 148.39C33.4439 147.829 33.8558 147.395 34.3728 147.089C34.8985 146.773 35.4812 146.615 36.1209 146.615C36.5941 146.615 37.0585 146.721 37.5141 146.931C37.9786 147.132 38.3466 147.404 38.6182 147.746V144.25H40.1298V153.976H38.6182V152.885C38.3729 153.236 38.0311 153.525 37.593 153.753C37.1636 153.98 36.6686 154.094 36.1077 154.094C35.4768 154.094 34.8985 153.937 34.3728 153.621C33.8558 153.297 33.4439 152.85 33.1372 152.281C32.8393 151.702 32.6903 151.049 32.6903 150.322ZM38.6182 150.348C38.6182 149.849 38.5131 149.415 38.3028 149.047C38.1012 148.679 37.834 148.399 37.501 148.206C37.168 148.013 36.8088 147.917 36.4232 147.917C36.0376 147.917 35.6784 148.013 35.3454 148.206C35.0124 148.39 34.7408 148.666 34.5305 149.034C34.3289 149.393 34.2282 149.823 34.2282 150.322C34.2282 150.822 34.3289 151.26 34.5305 151.636C34.7408 152.013 35.0124 152.302 35.3454 152.504C35.6871 152.697 36.0464 152.793 36.4232 152.793C36.8088 152.793 37.168 152.697 37.501 152.504C37.834 152.311 38.1012 152.031 38.3028 151.663C38.5131 151.286 38.6182 150.848 38.6182 150.348ZM48.7355 150.177C48.7355 150.449 48.718 150.694 48.683 150.914H43.1494C43.1932 151.492 43.4079 151.956 43.7934 152.307C44.179 152.657 44.6522 152.833 45.213 152.833C46.0191 152.833 46.5887 152.495 46.9217 151.82H48.5384C48.3193 152.486 47.9206 153.034 47.3423 153.463C46.7727 153.884 46.0629 154.094 45.213 154.094C44.5207 154.094 43.8986 153.941 43.3465 153.634C42.8033 153.319 42.3739 152.881 42.0584 152.32C41.7518 151.75 41.5984 151.093 41.5984 150.348C41.5984 149.604 41.7474 148.951 42.0453 148.39C42.352 147.82 42.777 147.382 43.3203 147.076C43.8723 146.769 44.5032 146.615 45.213 146.615C45.8965 146.615 46.5055 146.764 47.04 147.062C47.5745 147.36 47.9907 147.781 48.2886 148.324C48.5866 148.859 48.7355 149.476 48.7355 150.177ZM47.1714 149.704C47.1627 149.152 46.9655 148.71 46.5799 148.377C46.1944 148.044 45.7168 147.877 45.1473 147.877C44.6303 147.877 44.1878 148.044 43.8197 148.377C43.4517 148.701 43.2326 149.144 43.1625 149.704H47.1714ZM51.7085 147.798C51.9626 147.465 52.3088 147.185 52.7469 146.957C53.185 146.729 53.6801 146.615 54.2322 146.615C54.8631 146.615 55.437 146.773 55.954 147.089C56.4798 147.395 56.8916 147.829 57.1895 148.39C57.4875 148.951 57.6364 149.595 57.6364 150.322C57.6364 151.049 57.4875 151.702 57.1895 152.281C56.8916 152.85 56.4798 153.297 55.954 153.621C55.437 153.937 54.8631 154.094 54.2322 154.094C53.6801 154.094 53.1894 153.985 52.76 153.766C52.3307 153.538 51.9802 153.258 51.7085 152.925V157.42H50.2101V146.734H51.7085V147.798ZM56.1117 150.322C56.1117 149.823 56.0066 149.393 55.7963 149.034C55.5947 148.666 55.3231 148.39 54.9814 148.206C54.6484 148.013 54.2891 147.917 53.9036 147.917C53.5268 147.917 53.1675 148.013 52.8258 148.206C52.4928 148.399 52.2211 148.679 52.0108 149.047C51.8093 149.415 51.7085 149.849 51.7085 150.348C51.7085 150.848 51.8093 151.286 52.0108 151.663C52.2211 152.031 52.4928 152.311 52.8258 152.504C53.1675 152.697 53.5268 152.793 53.9036 152.793C54.2891 152.793 54.6484 152.697 54.9814 152.504C55.3231 152.302 55.5947 152.013 55.7963 151.636C56.0066 151.26 56.1117 150.822 56.1117 150.322ZM60.8663 147.956V151.965C60.8663 152.237 60.9277 152.434 61.0503 152.557C61.1818 152.67 61.4008 152.727 61.7075 152.727H62.6276V153.976H61.4447C60.7699 153.976 60.2529 153.818 59.8937 153.503C59.5344 153.187 59.3548 152.675 59.3548 151.965V147.956H58.5004V146.734H59.3548V144.933H60.8663V146.734H62.6276V147.956H60.8663ZM67.7547 146.615C68.3067 146.615 68.7974 146.734 69.2268 146.97C69.6649 147.207 70.0066 147.557 70.252 148.022C70.5061 148.486 70.6332 149.047 70.6332 149.704V153.976H69.1479V149.928C69.1479 149.279 68.9858 148.784 68.6616 148.442C68.3374 148.092 67.8949 147.917 67.334 147.917C66.7732 147.917 66.3263 148.092 65.9934 148.442C65.6692 148.784 65.507 149.279 65.507 149.928V153.976H64.0086V144.25H65.507V147.575C65.7612 147.268 66.081 147.032 66.4666 146.865C66.8609 146.699 67.2902 146.615 67.7547 146.615Z",
    fill: "#474D63"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M51.115 219.797L48.0106 215.289C47.5935 214.683 48.0271 213.858 48.7625 213.858L54.9714 213.858C55.7068 213.858 56.1404 214.683 55.7233 215.289L52.6189 219.797C52.2561 220.324 51.4778 220.324 51.115 219.797Z",
    fill: "#656D88"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M52.6204 12.4669L55.7248 16.9755C56.1419 17.5812 55.7082 18.4062 54.9728 18.4062L48.764 18.4062C48.0286 18.4062 47.5949 17.5812 48.012 16.9755L51.1164 12.4669C51.4793 11.9399 52.2575 11.9399 52.6204 12.4669Z",
    fill: "#656D88"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_13988_295305",
    x: 0.45459,
    y: 101.08,
    width: 102.441,
    height: 132.172,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.67664
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_13988_295305"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_13988_295305",
    x: 35.7354,
    y: 5.3208,
    width: 31.1777,
    height: 6.23535,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.890788
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_13988_295305"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_13988_295305",
    x: 0.54834,
    y: 0.421387,
    width: 102.44,
    height: 6.23535,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.668091
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.23 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_13988_295305"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_13988_295305",
    x1: 51.6753,
    y1: 164.232,
    x2: 51.6753,
    y2: 226.941,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3CBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6790E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_13988_295305",
    x1: 51.7681,
    y1: 0.421387,
    x2: 51.7681,
    y2: 222.54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3E3F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B6B6D5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaxDepth);
export default __webpack_public_path__ + "static/media/max_depth.dcadabd7a55b9a55bc71a1eb2cacbda7.svg";
export { ForwardRef as ReactComponent };